import blackicon from "../assets/person-black.svg";
import blueicon from "../assets/person-blue.svg";
import greenicon from "../assets/person-green.svg";
import orangeicon from "../assets/person-orange.svg";
import pinkicon from "../assets/person-pink.svg";
import yellowicon from "../assets/person-yellow.svg";
import burst from "../assets/person-purple-burst.svg";

const type = "bar";
const stack = true;
const colorTransparent = "rgba(255, 255, 255, 0)";
const splitLineColor = "rgba(126, 126, 126, 0.2)";
const fiftyPercentLineColor = "#333";
const axisLabelColor = "#000";
const fontFamily = 'Whyte, sans-serif';

export const isSmallScreen = window.innerWidth < 426;
export const isMediumScreen =
  window.innerWidth >= 426 && window.innerWidth < 769;
export const isLargeScreen = window.innerWidth >= 769;
const barWidth = isSmallScreen ? 24 : 40;

export const barLabelProps = {
  label: {
    fontSize: isSmallScreen || isMediumScreen ? 13 : 18,

  }
};

const iconPaths = [
  "",
  blackicon,
  blueicon,
  greenicon,
  yellowicon,
  orangeicon,
  pinkicon,
  burst
];

export const customColors = [
  "rgba(255, 255, 255, 0)",
  "#221649", // Purple
  "#4BA3B7", // Blue
  "#367D54", // Green
  "#FADE4B", // Yellow
  "#EB5534", // Orange
  "#ED7ACA" // Pink
];

export const stepFivePurpleColors = [
  customColors[1],
  customColors[1],
  customColors[4],
  customColors[3],
  customColors[6],
  customColors[2]
];

export const stepFiveOrangeColors = [
  customColors[5],
  customColors[5],
  customColors[4],
  customColors[3],
  customColors[6],
  customColors[2]
];

export const fiftyPercentLine = {
  silent: true,
  lineStyle: {
    color: fiftyPercentLineColor,
    type: "dashed",
    width: 3,
    opacity: 0.15
  },
  label: {
    show: false
  },
  symbolSize: 0,
  data: [
    {
      symbolOffset: [5, 5],
      y: 10,
      xAxis: 50
    }
  ],
  animation: false
};

export const genericProps = {
  type,
  barWidth,
  stack,
  silent: true,
  animation: true,
  animationEasing: "circularOut",
  animationEasingUpdate: "circularOut",
  animationDuration: 1000,
  animationDelay: function(idx) {
    return idx * 75;
  },
  animationDelayUpdate: function(idx) {
    return idx * 50;
  }
};
export const emptyDataObj = {
  value: null,
  itemStyle: {
    color: colorTransparent
  }
};

const iconStyleNames = [
  "",
  "purple",
  "blue",
  "green",
  "yellow",
  "orange",
  "pink",
  "purpleBurst"
];

const iconFadeStyleNames = [
  "",
  "purpleFade",
  "blueFade",
  "greenFade",
  "yellowFade",
  "orangeFade",
  "pinkFade",
  "purpleBurstFade"
];

const iconSpaces = {
  sm: [
    "",
    "                  ",
    "                  ",
    "                  ",
    "                  ",
    "                  ",
    "                  ",
	"          "
  ],
  md: ["", "    ", "    ", "    ", "    ", "   ", "   ", "  "]
};
const iconTextSpaces = {
  sm: ["", "          ", "              ", "           ", "          ", "        ", "              ", "        "],
  md: ["", "     ", "         ", "      ", "     ", "    ", "          ", " "]
};

function getIconStyles(hasVotingEnded) {
  let iconStyleProps = {};
  let iconFadeStyleProps = {};
  const textFade = {
    opacity: hasVotingEnded ? 0.05 : 0.2,
    fontWeight: 700,
    fontSize: isSmallScreen || isMediumScreen ? 14 : 21,
    fontFamily
  };

  iconPaths.forEach((iconPath, i) => {
    const burstIconHeightLarge = 50;
    const burstIconHeightSmall = 42;
    const iconHeightLarge = 22;
    const iconHeightSmall = 17;
    let iconHeight;
    let iconBurstHeight;

    if (isSmallScreen || isMediumScreen) {
      iconHeight = iconHeightSmall;
      iconBurstHeight = burstIconHeightSmall;
    } else {
      iconHeight = iconHeightLarge;
      iconBurstHeight = burstIconHeightLarge;
    }

    const updatedIconStyleProps = {
      backgroundColor: {
        image: iconPath
      },
      height: i === 7 ? iconBurstHeight : iconHeight,
      align: "right"
    };
    iconStyleProps = {
      ...iconStyleProps,
      ...{
        [iconStyleNames[i]]: {
          ...updatedIconStyleProps
        }
      }
    };
    iconFadeStyleProps = {
      ...iconFadeStyleProps,
      ...{
        [iconFadeStyleNames[i]]: {
          ...updatedIconStyleProps,
          ...textFade
        }
      }
    };
  });
  return { ...iconStyleProps, ...iconFadeStyleProps, textFade };
}

export function formatRounds(ballotRounds, stepValue,label) {
  let labelPosition = "right";
  let labelDistance = 15;
  let isLabelShown = false;
  let labelLayout = {
    hideOverlap: true,
    x: 10,
    dy: -6
  };
  const brLen = ballotRounds.length - 1;
  return ballotRounds.map((round, roundIndex) => {
    const getSum = series => {
      return param => {
        let sum = 0;
        series.forEach(seriesDatum => {
          sum += seriesDatum.data[param.dataIndex].value;
        });
        return param.dataIndex === 0 ? "" : `${sum} ${label}`;
      };
    };
    if (isSmallScreen) {
      labelPosition = "bottom";
    }
    if (isMediumScreen || isLargeScreen) {
      labelLayout = {
        hideOverlap: true
      };
    }
    if (stepValue === 2 || roundIndex === brLen) {
      isLabelShown = true;
    }

    return Object.assign(round, {
      label: {
        fontFamily,
        show: isLabelShown,
        formatter: stepValue === 1 ? "" : getSum(ballotRounds),
        position: labelPosition,
        distance: labelDistance,
		
	   
      },

      labelLayout: labelLayout
    });
  });
}

export function getChartConfig({ stepValue, hasVotingEnded,axisData,winnerText }) {
 
  const chartConfig = {

	
    title: {
      show: hasVotingEnded ? true : false,
      text: winnerText, //winnerText,
      left: isSmallScreen ? "0%" : "17%",
      top: isSmallScreen || isMediumScreen ? "37%" : "38%",
	  
      textStyle: {
        fontFamily,
        lineHeight: 42,
        color: customColors[1],
        fontWeight: 800,
        fontSize: isSmallScreen || isMediumScreen ? 26 : 36
      }
    },
    grid: {
      left: isSmallScreen ? 1 : 10,
      right: "5%",
      bottom: "5%",
      top: "-14%",
      height: isSmallScreen ? 505 : 645,
      width: isSmallScreen ? "106%" : "100%",
      containLabel: true
    },
    xAxis: {
      type: "value",
      inverse: false, // bar reverse line
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontFamily,
		color: "black",
        fontSize: isSmallScreen || isMediumScreen ? 14 : 18,
        padding:
          isSmallScreen || isMediumScreen ? [10, 0, 0, 10] : [15, 0, 0, 10],
        formatter: (value, index) => {
          if (isSmallScreen && index === 3) {
            return "";
          }
          if ((isMediumScreen || isLargeScreen) && index === 7) {
            return "";
          }
          return `${value}%`;
        }
      },
      interval: isSmallScreen ? 25 : 10,
      min: 0,
      max: isSmallScreen ? 60 : 70
    },
    yAxis: {
      type: "category",
      offset: 5,
      splitLine: {
        show: true,
        lineStyle: {
          width: 3,
          color: splitLineColor
        }
      },
      inverse: true,
      data: axisData,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontFamily,
        color: axisLabelColor,
        fontSize: isSmallScreen || isMediumScreen ? 14 : 21,
        fontWeight: "bolder",
        formatter: (axisLabel, axisIndex) => {
        //   if (isSmallScreen) {
        //     if (axisIndex === 2) {
        //       if (stepValue >= 6) {
        //         return [
        //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}
   
		//   {textFade|${axisLabel}}${iconTextSpaces.sm[axisIndex]}` 
        //         ];
        //       }
        //     }
        //     if (axisIndex === 3) {
        //       if (stepValue >= 4) {
        //         return [
        //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}
   
		//   {textFade|${axisLabel}}${iconTextSpaces.sm[axisIndex]}`
        //         ];
        //       }
        //     }
        //     if (axisIndex === 4) {
        //       if (stepValue >= 3) {
        //         return [
        //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}
   
		//   {textFade|${axisLabel}}${iconTextSpaces.sm[axisIndex]}`
        //         ];
        //       }
        //     }
        //     if (axisIndex === 6) {
        //       if (stepValue >= 5) {
        //         return [
        //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}
   
		//   {textFade|${axisLabel}}${iconTextSpaces.sm[axisIndex]}`
        //         ];
        //       }
        //     }
        //     if (hasVotingEnded && axisIndex === 1) {
        //       return [
        //         `{${iconStyleNames[7]}|}${iconSpaces.sm[7]}
		//   ${axisLabel}${iconTextSpaces.sm[7]}`
        //       ];
        //     }

        //     return [
        //       `{${iconStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}
   
		// 	  ${axisLabel}${iconTextSpaces.sm[axisIndex]}`
        //     ];
        //   } else {
        //     if (axisIndex === 2) {
        //       if (stepValue >= 6) {
        //         return [
        //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}{textFade|${axisLabel}}${iconTextSpaces.md[axisIndex]}`
        //         ];
        //       }
        //     }
        //     if (axisIndex === 3) {
        //       if (stepValue >= 4) {
        //         return [
        //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}{textFade|${axisLabel}}${iconTextSpaces.md[axisIndex]}`
        //         ];
        //       }
        //     }
        //     if (axisIndex === 4) {
        //       if (stepValue >= 3) {
        //         return [
        //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}{textFade|${axisLabel}}${iconTextSpaces.md[axisIndex]}`
        //         ];
        //       }
        //     }
        //     if (axisIndex === 6) {
        //       if (stepValue >= 5) {
        //         return [
        //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}{textFade|${axisLabel}}${iconTextSpaces.md[axisIndex]}`
        //         ];
        //       }
        //     }
        //     if (hasVotingEnded && axisIndex === 1) {
        //       return [
        //         `{${iconStyleNames[7]}|}${iconSpaces.md[7]}${axisLabel}${iconTextSpaces.md[7]}`
        //       ];
        //     }

        //     return [
        //       `{${iconStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}${axisLabel}${iconTextSpaces.md[axisIndex]}`
        //     ];
        //   }
        },

        verticalAlign: "middle",
       // textAlign: "right",
        rich: {
          ...getIconStyles(hasVotingEnded)
        }
      }
    }
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./src/config/chart-config.js